import { Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

const ignoredTargets = '[data-slate-node="text"], [contenteditable="false"], button, input, textarea, .node-handles-container';

function isOnItemBackground(event) {

  const target = event.target;

  if (target.closest(ignoredTargets) !== null || target.closest('.layout-cell') !== event.currentTarget) {
    return false;
  }

  const block = target.closest('[data-slate-node="element"]');

  return block !== null && block.classList.contains('layout-wrapper') === true;

}

// A click on the empty, stretched part of a layout item puts the caret at the end of that item.
export function placeCaretInItem(editor, element, index, event) {

  if (event.button !== 0 || isOnItemBackground(event) === false) {
    return;
  }

  event.preventDefault();
  Transforms.select(editor, Editor.end(editor, ReactEditor.findPath(editor, element).concat(index)));
  ReactEditor.focus(editor);

}
